import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {Zeitstate} from '../../store/reducer/zeiterfassung.reducer';
import {SpesenartItem} from '../../spesenart.model';
import {editZeitStart} from '../../store/actions/Zeit-edit.actions';
import {addZeitStart} from '../../store/actions/Zeit-add.actions';
import {addSpesenStart} from '../../store/actions/spesen-add.actions';
import {editSpesenStart} from "../../store/actions/spesen-edit.actions";
import {loadSpesenStart} from '../../store/actions/getAllSpesen.actions';
import {loadSpesenartenStart} from '../../store/actions/spesenart.actions';
import {map} from 'rxjs/operators';
import {BreakpointObserver} from '@angular/cdk/layout';

export interface DialogData{
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
  id: number;
  zeitId: number;
  rspeId: number;
  spesenArt: string;
  beschreibung: string;
  menge: number;
  betragInt: number;
  betragExt: number;
  ansatzInt: number;
  ansatzExt: number;
}

@Component({
  selector: 'app-spesen-formdialog',
  templateUrl: './spesen-formdialog.component.html',
  styleUrls: ['./spesen-formdialog.component.scss']
})


export class SpesenFormdialogComponent implements OnInit {



  constructor(public dialogRef: MatDialogRef<SpesenFormdialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              public store: Store<{ zeiterfassung: Zeitstate }>,
              private breakpointObserver: BreakpointObserver
  ) {
    this.$spesenarten = store.pipe(select((state) => state.zeiterfassung.spesenarten));

    if (data.menge === null || data.menge === 0){
      data.ansatzInt = null;
      data.ansatzExt = null;
    }
    else{
      data.ansatzInt = (data.betragInt / data.menge);
      data.ansatzExt = (data.betragExt / data.menge);
    }


    this.spesenForm.patchValue({
      spesencode: data.spesenArt,
      menge: data.menge?.toFixed(2),
      ansatzInt: data.ansatzInt?.toFixed(2),
      betragInt: data.betragInt?.toFixed(2),
      ansatzExt: data.ansatzExt?.toFixed(2),
      betragExt: data.betragExt?.toFixed(2),
      beschreibung: data.beschreibung,
      zeitId: data.zeitId,
      id: data.id,
    });
  }

  public $spesenarten: Observable<SpesenartItem[]>;
  public isSmallDevice = false;

  public spesenForm = new FormGroup({
    spesencode: new FormControl('', [Validators.required]),
    menge: new FormControl('' , [Validators.required, Validators.maxLength(255)]),
    ansatzInt: new FormControl('', [Validators.maxLength(255)]),
    betragInt: new FormControl('', [Validators.required , Validators.maxLength(255) ]),
    ansatzExt: new FormControl('', [Validators.maxLength(255) ]),
    betragExt: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    beschreibung: new FormControl('' , [Validators.maxLength(255)]),
    zeitId: new FormControl(''),
    id: new FormControl(''),
  });

  public getErrorMessage(formField: string): string {
    const formControl = this.spesenForm.get(formField);
    if ( formControl.hasError('required')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.pflichtfeld`;
    }
    else if ( formControl.hasError('minlength')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.minlength`;
    }
    else if ( formControl.hasError('maxlength')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.maxlength`;
    }
    else if ( formControl.hasError('min')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.min`;
    }
    else if ( formControl.hasError('pattern')){
      return `pages.zeitverwaltung.spesenDialog.err.${formField}.pattern`;
    }
    return 'pages.zeitverwaltung.spesenDialog.err.generic';
  }

  public handleSubmitClick(): void{
    const item = this.spesenForm.value;
    if (this.data.id){
      console.log(item);
      // edit da ID gesetzt ist
      this.store.dispatch(editSpesenStart({ item }));
    } else {
      // add da keine ID gesetzt ist
      this.store.dispatch(addSpesenStart({ item }));
    }
    this.dialogRef.close(true);
  }
  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }

  public fillUpAnsatz(spesen: SpesenartItem): void{
    this.spesenForm.patchValue({
      ansatzInt: spesen.ansatzInt?.toFixed(2),
      ansatzExt: spesen.ansatzExt?.toFixed(2),
      }
    );
}
  compareFn(c1: SpesenartItem, c2: number): boolean {
    return c1 && c2 ? c1.id === c2 : false;
  }

  public rechneBetrag(): void {
    if (this.spesenForm.value.ansatzInt != 0 && this.spesenForm.value.ansatzInt !== undefined && this.spesenForm.value.menge != 0 && this.spesenForm.value.menge !== undefined){
      this.spesenForm.value.betragInt = this.spesenForm.value.ansatzInt * this.spesenForm.value.menge;
      this.spesenForm.patchValue({
        betragInt: this.spesenForm.value.betragInt.toFixed(2)
      });
    }

    if (this.spesenForm.value.ansatzExt != 0 && this.spesenForm.value.ansatzExt !== undefined && this.spesenForm.value.menge != 0 && this.spesenForm.value.menge !== undefined){
      this.spesenForm.value.betragExt = this.spesenForm.value.ansatzExt * this.spesenForm.value.menge;
      this.spesenForm.patchValue({
        betragExt: this.spesenForm.value.betragExt.toFixed(2)
      });
    }
  }
  ngOnInit(): void {
    this.store.dispatch(loadSpesenartenStart());

    this.breakpointObserver
      .observe(localStorage.getItem('phoneWidth'))
      .pipe(map((result) => result.matches))
      .subscribe((isSmallDevice) => {
        this.isSmallDevice = isSmallDevice;

      });
  }

}
